import * as React from 'react';
import * as POIModule from 'Modules/POIModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as UserModule from 'Modules/UserModule';
import * as NotificationModule from 'Modules/NotificationModule';
import * as AlertModule from 'Modules/AlertModule';
import * as Dictionary from 'Models/Dictionary';
import * as L from 'leaflet';
import { Marker, Circle, Popup } from 'react-leaflet';
import { connect} from 'react-redux';
import {getFormValues} from 'redux-form';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { AddPOI } from 'components/Map/MapHelpers/AddPoi';
import { DateTimeComponent, LeafletIconCreator } from '../CarDetails/Composites/_CompositesHelpers';
import { withTranslation } from 'react-i18next';
import { RootState } from 'Redux/Reducers/_RootReducer';
import i18next from 'i18next';

export const osmURL = process.env.REACT_APP_mapURL+'/tile/{z}/{x}/{y}.png';
export const mapBounds: L.LatLngBoundsExpression = [[-89.98155760646617, -180], [89.99346179538875, 180]];
export const maxZoom = 18;
export const minZoom = 3;
export const mapOptions = {
    closePopupOnClick: true
};

// export const PreviewPoiDetails = (props: { poiDetails: POIModule.Types.PointOfInterestDto; onDelete: Function }) => {
//     return (
//         <div className="poipreview">
//             <div className="poipreview__title">
//                 <h5>Szczegóły POI</h5>
//             </div>
//             <div className="poipreview__content">
//                 <p className="bold poipreview__heading">Nazwa POI</p>
//                 <p>{props.poiDetails.title}</p>
//                 <p className="bold poipreview__heading">Zasięg POI</p>
//                 <p>{props.poiDetails.radiusMeters}</p>
//             </div>
//             <div className="poipreview__buttons">
//                 <div className="poiForm__button-delete" onClick={async () => props.onDelete(props.poiDetails.id)}>
//                     <img width="30" src={'/images/icons/garbage.svg'} />
//                     <span className="btn btn--clean">Usuń</span>
//                 </div>
//             </div>
//         </div>
//     );
// };

export function createAddressString(addressData: UserModule.Types.OSMAddress): string {
    let address: string = '';
    if (addressData && addressData.city) {
        address += `${addressData.road || ''} ${addressData.house_number || ''}, ${addressData.postcode || ''} ${addressData.city || ''} `;
    } else if (addressData) {
        address += `${addressData.postcode || ''} ${addressData.village || ''} ${addressData.county}`;
    } else {
        address += '';
    }
    return address;
}

export function generateIconHelperData(carCategory: VehiclesModule.EnumTypes.CarCategory, carEnumSpeed: VehiclesModule.EnumTypes.VehicleSpeedEnum): VehiclesModule.Types.IconHelper {
    let iconHelper: VehiclesModule.Types.IconHelper = {};
    if (carEnumSpeed === VehiclesModule.EnumTypes.VehicleSpeedEnum.GREY) {
        iconHelper = {
            imageUrl: Dictionary.TurnedOffCarCategoryImage.get(carCategory),
            imageSize: [50, 50]
        };
    } else {
        switch (carCategory) {
            case VehiclesModule.EnumTypes.CarCategory.PASSENGER_CAR:
                iconHelper = {
                    imageUrl: Dictionary.PassengerCarSpeedIcons.get(carEnumSpeed),
                    imageSize: [60, 60]
                };
                break;
            case VehiclesModule.EnumTypes.CarCategory.VAN:
                iconHelper = {
                    imageUrl: Dictionary.VanSpeedIcons.get(carEnumSpeed),
                    imageSize: [50, 75]
                };
                break;
            case VehiclesModule.EnumTypes.CarCategory.TRUCK:
                iconHelper = {
                    imageUrl: Dictionary.TruckSpeedIcons.get(carEnumSpeed),
                    imageSize: [50, 75]
                };
                break;
            case VehiclesModule.EnumTypes.CarCategory.MACHINE:
                iconHelper = {
                    imageUrl: Dictionary.MachineSpeedIcons.get(carEnumSpeed),
                    imageSize: [50, 75]
                };
                break;
            case VehiclesModule.EnumTypes.CarCategory.SEMI_TRAILER:
                iconHelper = {
                    imageUrl: Dictionary.SemiTrailerSpeedIcons.get(carEnumSpeed),
                    imageSize: [50, 75]
                };
                break;
            default:
                break;
        }
    }
    return iconHelper;
}
const createClusterCustomIcon = function(cluster: L.MarkerCluster) {
    const clusterColor = getClusterColor(cluster.getAllChildMarkers());
    return L.divIcon({
        html: `<div><span>${cluster.getChildCount()}</span></div>`,
        className: `marker-cluster marker-cluster-small marker-cluster-custom cluster-${clusterColor.toLowerCase()}`,
        iconSize: L.point(40, 40, true)
    });
};

export const getMarkerHtml = (props: CarMarkerListP & CarMarkerListDispatchedP,element: VehiclesModule.Types.CarDto)=> {
    const activeClass = (props.carMarkerActive && element.id == props.carMarkerActive.id)?' activeCar ':'';
    const iconHelper: VehiclesModule.Types.IconHelper = generateIconHelperData(element.carCategory, element.latestDataframe.speedLimitExceedance);
    return `<p class="vehicle-icon__title ${activeClass}"><span class="car-Name">${element.name || element.vin}</span></br><span class="car-DeviceId">${element.deviceId}</span></p> 
    <div class="car-Img ${activeClass}" style="transform: rotate(${element.latestDataframe.heading ? `${element.latestDataframe.heading}deg` : '0deg'})"><img class="car-ImgEl" src="${iconHelper.imageUrl}"></div>`
}

const CarMarkerListv2 = (props: CarMarkerListP & CarMarkerListDispatchedP) => {
    const { carsList, onClick, mapCurrentZoom } = props;
    return (
        <MarkerClusterGroup showCoverageOnHover={false} iconCreateFunction={createClusterCustomIcon}>
            {carsList.map((element: VehiclesModule.Types.CarDto, i: number) => {
                if (element.latestDataframe) {
                    const iconHelper: VehiclesModule.Types.IconHelper = generateIconHelperData(element.carCategory, element.latestDataframe.speedLimitExceedance);
                    const html =
                        mapCurrentZoom > 8
                            ? getMarkerHtml(props,element)
                            : `<img style="transform: rotate(${element.latestDataframe.heading ? `${element.latestDataframe.heading}deg` : '0deg'})" src="${iconHelper.imageUrl}">`;
                    const Icon = L.divIcon({
                        iconUrl: iconHelper.imageUrl,
                        iconSize: iconHelper.imageSize,
                        html,
                        className: `vehicle-icon vehicle-icon__${element.latestDataframe.speedLimitExceedance.toLowerCase()}`
                    });

                    return (
                        <Marker
                            onClick={() => onClick(element)}
                            key={i}
                            position={{
                                lat: element.latestDataframe.latitude,
                                lng: element.latestDataframe.longitude
                            }}
                            icon={Icon}
                        />
                    );
                }
            })}
        </MarkerClusterGroup>
    );
};
type CarMarkerListDispatchedP = {
    carMarkerActive?:VehiclesModule.Types.CarDto
}
type CarMarkerListP = {
    carsList: Array<VehiclesModule.Types.CarDto>;
    onClick: Function;
    mapCurrentZoom: number
}
function carMarkerListmapStateToProps(state: RootState): CarMarkerListDispatchedP {
    return {
        carMarkerActive:state.vehiclesStore.activeVehicleDetails
    };
}

export const CarMarkerList = connect(
    carMarkerListmapStateToProps,
    null
)(CarMarkerListv2);

type PoiMarkerListDispatchedP = {
    poiStore: POIModule.Types.POIStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    formSlide:any,
    formPoiID:number
};
type PoiMarkerListConnectedP = {
    hidePoiDetails: () => void;
    deletePoi: (poiID: number) => void;
    updatePoi: (poiData: POIModule.Types.UpdatePointOfinterestRequest, poiID: number) => void;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
    setActivePoi: (activePoi: POIModule.Types.PointOfInterestDto) => void;
};
type PoiMarkerListP = {
    onClick: Function;
    mapCurrentZoom: number;
};
export const PoiMarkerListv2 = (props: PoiMarkerListDispatchedP & PoiMarkerListConnectedP & PoiMarkerListP) => {
    const { poiStore, onClick, hidePoiDetails, showPopup, mapCurrentZoom } = props;
    const { PopupType } = ViewManagementModule.VMEnumTypes;
    const updatePOi = async (data: POIModule.Types.PointOfInterestDto) => {
        const { title, address, latitude, longitude, radiusMeters } = data;
        const poiData: POIModule.Types.UpdatePointOfinterestRequest = { title, address, latitude, longitude, radiusMeters };
        await props.updatePoi(poiData, props.poiStore.activePoi.id);
    };
    const deletePOi = async () => {
        showPopup({
            type: PopupType.DELETE_POI,
            confirmCallback: async () => {
                await props.deletePoi(poiStore.activePoi.id);
                hidePoiDetails();
            }
        });
    };

    return (
        <>
            {poiStore.poiList.map((e, i) => {
                const html =
                    mapCurrentZoom > 8
                        ? `<p class="vehicle-icon__title">${e.title}</p> 
                 <img src="/images/icons/poi_marker.svg">`
                        : `<img src="/images/icons/poi_marker.svg">`;
                const lat = e.latitude;
                const lng = e.longitude;
                const icon = L.divIcon({
                    iconUrl: '/images/icons/poi_marker.svg',
                    iconSize: [25, 35],
                    html,
                    className: `poi-marker `
                });
                return (
                    <React.Fragment key={i}>
                        <Marker
                            key={i}
                            position={{ lat, lng }}
                            icon={icon}
                            onClick={() => {
                                onClick(e);
                            }}
                        >
                            <Circle center={{ lat, lng }} radius={((e.id==props.formPoiID)?props.formSlide:e.radiusMeters)} />
                        </Marker>
                    </React.Fragment>
                );
            })}
        </>
    );
};
function mapStateToProps(state: any): PoiMarkerListDispatchedP {
    const valuesForm:any = getFormValues('addPoiForm')(state)
    return {
        poiStore: state.poiStore,
        viewManagementStore: state.viewManagementStore,
        formSlide:(valuesForm)?valuesForm.radiusMeters:0,
        formPoiID:(valuesForm)?valuesForm.id:null
    };
}

function mapDispachToProps(dispatch: any): PoiMarkerListConnectedP {
    return {
        hidePoiDetails: () => dispatch(POIModule.Actions.hidePoiDetailsPopup()),
        deletePoi: (poiID: number) => dispatch(POIModule.Actions.deletePoi(poiID)),
        setActivePoi: (activePoi: POIModule.Types.PointOfInterestDto) => dispatch(POIModule.Actions.setDetailsForPoiView(activePoi)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        updatePoi: (poiData: POIModule.Types.UpdatePointOfinterestRequest, poiID: number) => dispatch(POIModule.Actions.updatePoi(poiData, poiID))
    };
}
export const PoiMarkerList = connect(
    mapStateToProps,
    mapDispachToProps
)(PoiMarkerListv2);

export function copy(o) {
    let output;
    let v;
    let key;
    output = Array.isArray(o) ? [] : {};
    for (key in o) {
        v = o[key];
        output[key] = typeof v === 'object' ? copy(v) : v;
    }
    return output;
}
export function arraysEqual(a1, a2) {
    return JSON.stringify(a1) == JSON.stringify(a2);
}

export function getClusterColor(markersArr: Array<L.Marker>): VehiclesModule.EnumTypes.VehicleSpeedEnum {
    let currentValue: number = 0;
    markersArr.forEach((e, i) => {
        const markerVehicleSpeedEnum = Dictionary.VehicleSpeedIconsReverse.get(e.options.icon.options.iconUrl);
        if (markerVehicleSpeedEnum && markerVehicleSpeedEnum.value > currentValue) {
            currentValue = markerVehicleSpeedEnum.value;
        }
    });
    return Dictionary.VehicleSpeedEnumValueDictionary.get(currentValue);
}

const NotificationMarkerComponent = (props: { notification: NotificationModule.Types.NotificationDto; t?: i18next.TFunction }) => {
    const { notification, t } = props;
    const [popupVisible, setPopupVisibility] = React.useState(true);
    const getIconUrl = generateIconForNotification(notification.priority || AlertModule.EnumTypes.Priority.LOW);
    const position = {
        lat: notification.dataframe.latitude,
        lng: notification.dataframe.longitude
    };
    return (
        <>
            <Marker onClick={() => setPopupVisibility(!popupVisible)} position={position} icon={LeafletIconCreator(getIconUrl)} />
            {popupVisible && (
                <Popup className="pathpoint_popup_details" position={position} autoPan={false}>
                    <div className="pathpoint_popup_details__data">
                        <DateTimeComponent date={notification.dataframe.dateTime} />
                        <p className="font-sm">
                            <span className="font-grey-light">{t('type')}:</span>{' '}
                            <span className="font-bold ">{notification.alertCondition ? t(`carDetails:${notification.alertCondition}`) : t(`carDetails:${notification.event}`)}</span>
                        </p>
                        <p className="font-sm">
                            <span className="font-grey-light">{t(`carDetails:name`)}:</span> <span className="font-bold">{notification.title}</span>
                        </p>
                        <p className="font-sm">
                            <span className="font-grey-light">{t('description')}:</span> <span className="font-bold ">{notification.message}</span>
                        </p>
                    </div>
                </Popup>
            )}
        </>
    );
};
export const NotificationMarker = withTranslation ('dictionary')(NotificationMarkerComponent as React.ComponentType<any>);

export const generateIconForNotification = (notificationPriority: AlertModule.EnumTypes.Priority) => {
    switch (notificationPriority) {
        case AlertModule.EnumTypes.Priority.HIGH: {
            return '/images/icons/priority_red.svg';
        }
        case AlertModule.EnumTypes.Priority.MEDIUM: {
            return '/images/icons/priority_yellow.svg';
        }
        case AlertModule.EnumTypes.Priority.LOW: {
            return '/images/icons/priority_blue.svg';
        }
        default:
            return '/images/icons/priority_blue.svg';
    }
};



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/MapHelpers.tsx